import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { useApp } from "../context/AppContext";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_timeshare-calculator/artifacts/7gkgelre_LOGOTIPO%20ALTERNATIVO%20blanco.png";

const AdminLogin = () => {
  const { login } = useAuth();
  const { t } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="ourigen-pattern flex min-h-screen items-center justify-center px-6"
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-md border border-white/10 bg-[#131316]/90 p-10 text-white backdrop-blur-md">
        <div className="flex flex-col items-center">
          <img src={LOGO_URL} alt="Ourigen" className="h-16 w-16 object-contain" />
          <span className="mt-3 font-display tracking-[0.4em]">OURIGEN</span>
          <h1 className="mt-6 font-display text-2xl">{t("admin_title")}</h1>
        </div>
        <form onSubmit={submit} className="mt-10 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="text-xs uppercase tracking-luxury text-white/60">
              {t("admin_email")}
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-2 w-full border-0 border-b border-white/20 bg-transparent px-0 py-3 font-display text-xl text-white outline-none focus:border-[#D4AF37]"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-luxury text-white/60">
              {t("admin_password")}
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-2 w-full border-0 border-b border-white/20 bg-transparent px-0 py-3 font-display text-xl text-white outline-none focus:border-[#D4AF37]"
              data-testid="admin-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="mt-4 w-full bg-[#D4AF37] py-4 text-xs font-bold uppercase tracking-luxury text-black transition-colors hover:bg-white disabled:opacity-50"
            data-testid="admin-login-btn"
          >
            {loading ? "..." : t("admin_login")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
